import { type BoxProps, Flex, Image } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, FooterDataSdk, Pages } from "~/core";
import { FooterDescription } from "~/features/footerV3/components/FooterDescription";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

import { FooterControls } from "./components/FooterControls";
import { FooterMenu } from "./components/FooterMenu";

export type FooterV3Props = {
  data: FooterDataSdk;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  isControlInactive: (control: Action) => boolean;
} & Partial<
  Omit<BoxProps, "display" | "as" | "children" | "className" | "onClick">
>;
export const FooterV3: FC<FooterV3Props> = (props) => {
  const { data, ...rest } = props;

  const { getDirectusImage } = useDirectus();
  return (
    <Flex
      d={{ p: { py: 64 } }}
      as="section"
      justify="center"
      flexDirection="column"
      align="center"
      {...rest}
    >
      <Flex justify="center" d={{ justify: "flex-start" }} width="100%">
        <Image
          value={getDirectusImage(data?.logo?.id ?? "", {
            format: "webp",
            width: 190,
          })}
        />
      </Flex>

      <FooterMenu {...props} />

      <FooterControls {...props} />

      <FooterDescription {...props} />
    </Flex>
  );
};
